import { useEffect, useState } from "react";

import { Button, Span } from "@virtual-brain-lib/frontend-design-system/ui";

export default function MessageRetry({
	onRetry,
	isMessageProcessing,
}: {
	readonly onRetry: () => void;
	readonly isMessageProcessing: boolean | undefined;
}) {
	const [hasRetried, setHasRetried] = useState(false);

	function retry() {
		if (hasRetried) {
			return;
		}

		setHasRetried(true);
		onRetry?.();
	}

	useEffect(() => {
		if (isMessageProcessing && hasRetried) {
			setHasRetried(false);
		}
	}, [isMessageProcessing, hasRetried]);

	return (
		<div className="mb-2 flex flex-col gap-2 rounded-lg border border-warning-border bg-warning-light px-4 py-3 text-on-warning shadow-xs">
			<Span variant="body-sm" className="text-sm">
				Oops! Something went wrong. It could be due to an unstable internet connection or
				high demand on our servers. Please try again.
			</Span>
			<Button
				size="sm"
				variant="outline"
				color="warning"
				className="w-fit"
				disabled={isMessageProcessing ?? hasRetried}
				onClick={retry}
			>
				Retry Request
			</Button>
		</div>
	);
}
